export const common = {
  // Header
  'header.home': 'الرئيسية',
  'header.about': 'من نحن',
  'header.faq': 'الأسئلة الشائعة',
  'header.contact': 'اتصل بنا',
  'header.signIn': 'تسجيل الدخول',
  'header.getStarted': 'ابدأ الآن',

  // Footer
  'footer.tagline': 'ارتقِ بمستقبلك المالي',
  'footer.description': 'حلول دفع آمنة وموثوقة ومبتكرة للأفراد والشركات في جميع أنحاء العالم.',
  'footer.quickLinks': 'روابط سريعة',
  'footer.services': 'الخدمات',
  'footer.contact': 'اتصل بنا',
  'footer.address': '789 Summit Avenue, San Francisco, CA 94102',
  'footer.email': 'support@pinnaclepayments.com',
  'footer.phone': '+1 (415) 555-1234',
  'footer.copyright': '© 2024 Pinnacle Payments. جميع الحقوق محفوظة.',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'شروط الخدمة',

  // Home Page
  'home.hero.title': 'ارتقِ بمستقبلك المالي',
  'home.hero.subtitle': 'اختبر الخدمات المصرفية السلسة مع التكنولوجيا المتطورة. أدر ثروتك، واستثمر بذكاء، وحقق أهدافك المالية مع Pinnacle Payments.',
  'home.hero.cta': 'ابدأ اليوم',
  'home.hero.learn': 'اعرف المزيد',

  'home.stats.users': 'مستخدم نشط',
  'home.stats.countries': 'دولة مخدومة',
  'home.stats.transactions': 'معاملة معالجة',
  'home.stats.support': 'دعم 24/7',

  'home.services.title': 'خدماتنا المميزة',
  'home.services.subtitle': 'حلول مالية شاملة مصممة خصيصاً لاحتياجاتك',

  'home.services.banking.title': 'الخدمات المصرفية الرقمية',
  'home.services.banking.desc': 'الخدمات المصرفية الحديثة في متناول يدك مع التحويلات الفورية ودفع الفواتير وتتبع الرصيد في الوقت الفعلي.',

  'home.services.investment.title': 'حلول الاستثمار',
  'home.services.investment.desc': 'نمِّ ثروتك مع محافظنا الاستثمارية المنسقة والإرشاد المالي من الخبراء.',

  'home.services.loans.title': 'قروض مرنة',
  'home.services.loans.desc': 'قروض شخصية وتجارية سريعة الموافقة بأسعار تنافسية وشروط سداد مرنة.',

  'home.services.cards.title': 'بطاقات افتراضية',
  'home.services.cards.desc': 'بطاقات خصم وائتمان افتراضية آمنة للتسوق عبر الإنترنت والمعاملات الدولية الآمنة.',

  'home.features.title': 'لماذا تختار Pinnacle Payments',
  'home.features.subtitle': 'اختبر التميز المصرفي مع ميزات رائدة في الصناعة',

  'home.features.security.title': 'أمان على مستوى البنوك',
  'home.features.security.desc': 'أموالك محمية بتشفير عسكري ومصادقة متعددة العوامل.',

  'home.features.instant.title': 'تحويلات فورية',
  'home.features.instant.desc': 'أرسل واستقبل الأموال فوراً في أكثر من 180 دولة بدون تأخير.',

  'home.features.support.title': 'دعم خبراء 24/7',
  'home.features.support.desc': 'فريقنا المخصص متاح دائماً لمساعدتك في أي أسئلة أو مخاوف.',

  'home.features.rates.title': 'أسعار تنافسية',
  'home.features.rates.desc': 'استمتع بأفضل أسعار الصرف وأقل الرسوم في الصناعة لجميع المعاملات.',

  'home.plans.title': 'خطط النمو المالي',
  'home.plans.subtitle': 'اختر الخطة المثالية لتحقيق أهدافك المالية',

  'home.plans.dps.title': 'نظام معاش الإيداع',
  'home.plans.dps.rate': 'العائد السنوي',
  'home.plans.dps.term': 'شروط مرنة',
  'home.plans.dps.feature1': 'خيارات الإيداع الشهري',
  'home.plans.dps.feature2': 'عوائد مضمونة',
  'home.plans.dps.feature3': 'مزايا ضريبية',
  'home.plans.dps.feature4': 'خيار السحب المبكر',
  'home.plans.dps.cta': 'ابدأ الادخار',

  'home.plans.fdr.title': 'إيصال الإيداع الثابت',
  'home.plans.fdr.rate': 'معدل الفائدة',
  'home.plans.fdr.term': 'فترة القفل',
  'home.plans.fdr.feature1': 'عوائد عالية مضمونة',
  'home.plans.fdr.feature2': 'خيارات مدة مرنة',
  'home.plans.fdr.feature3': 'قرض مقابل FDR',
  'home.plans.fdr.feature4': 'التجديد التلقائي متاح',
  'home.plans.fdr.cta': 'استثمر الآن',

  'home.plans.loan.title': 'قروض شخصية',
  'home.plans.loan.rate': 'ابتداءً من',
  'home.plans.loan.term': 'فترة السداد',
  'home.plans.loan.feature1': 'موافقة سريعة في 24 ساعة',
  'home.plans.loan.feature2': 'بدون رسوم مخفية',
  'home.plans.loan.feature3': 'خيارات EMI مرنة',
  'home.plans.loan.feature4': 'الحد الأدنى من الوثائق',
  'home.plans.loan.cta': 'قدم الآن',

  'home.testimonials.title': 'ماذا يقول عملاؤنا',
  'home.testimonials.subtitle': 'انضم إلى آلاف العملاء الراضين في جميع أنحاء العالم',

  'home.cta.title': 'هل أنت مستعد لتحويل مستقبلك المالي؟',
  'home.cta.subtitle': 'انضم إلى ملايين المستخدمين الذين يثقون في Pinnacle Payments لتلبية احتياجاتهم المالية',
  'home.cta.button': 'أنشئ حسابك',

  // About Page
  'about.hero.title': 'حول Pinnacle Payments',
  'about.hero.subtitle': 'قيادة مستقبل التمويل الرقمي منذ 2010',

  'about.story.title': 'قصتنا',
  'about.story.content': 'تأسست Pinnacle Payments في عام 2010، وانبثقت من رؤية لإحداث ثورة في صناعة الخدمات المالية. أدركنا أن الخدمات المصرفية التقليدية كانت تفشل في تلبية احتياجات عالم رقمي سريع التطور. انطلق مؤسسونا، وهم فريق من رواد التكنولوجيا المالية وخبراء الخدمات المصرفية، لإنشاء منصة تجمع بين التكنولوجيا المتطورة والخدمة الشخصية. اليوم، نخدم أكثر من 8 ملايين عميل في 180 دولة، ونعالج مليارات المعاملات سنوياً مع الحفاظ على التزامنا بالأمان والابتكار ورضا العملاء.',

  'about.mission.title': 'مهمتنا',
  'about.mission.content': 'تمكين الأفراد والشركات في جميع أنحاء العالم بحلول مالية يسهل الوصول إليها وآمنة ومبتكرة تمكنهم من تحقيق أهدافهم وبناء الازدهار الدائم.',

  'about.vision.title': 'رؤيتنا',
  'about.vision.content': 'أن نصبح المنصة المالية الرقمية الأكثر موثوقية في العالم، ووضع معايير جديدة للتميز والأمان وتجربة العملاء في صناعة التكنولوجيا المالية.',

  'about.stats.customers': 'عميل سعيد',
  'about.stats.transactions': 'معاملة معالجة',
  'about.stats.countries': 'دولة حول العالم',
  'about.stats.rating': 'تقييم العملاء',

  'about.values.title': 'قيمنا الأساسية',
  'about.values.security.title': 'الأمان أولاً',
  'about.values.security.desc': 'نعطي الأولوية لسلامة أموالك وبياناتك قبل كل شيء.',
  'about.values.innovation.title': 'الابتكار',
  'about.values.innovation.desc': 'التطور المستمر لتوفير حلول مالية متطورة.',
  'about.values.transparency.title': 'الشفافية',
  'about.values.transparency.desc': 'تواصل واضح وممارسات صادقة في كل ما نقوم به.',
  'about.values.excellence.title': 'التميز',
  'about.values.excellence.desc': 'تقديم خدمة ونتائج استثنائية لعملائنا.',

  'about.team.title': 'تعرف على فريق القيادة لدينا',
  'about.team.subtitle': 'محترفون ذوو خبرة يقودون الابتكار في التكنولوجيا المالية',

  // FAQ Page
  'faq.title': 'الأسئلة الشائعة',
  'faq.subtitle': 'ابحث عن إجابات للأسئلة الشائعة حول خدماتنا',

  'faq.general': 'عام',
  'faq.account': 'الحساب',
  'faq.security': 'الأمان',
  'faq.payments': 'المدفوعات',

  // Contact Page
  'contact.title': 'تواصل معنا',
  'contact.subtitle': 'نحن هنا للمساعدة في أي أسئلة أو مخاوف',

  'contact.info.title': 'معلومات الاتصال',
  'contact.info.address': 'زرنا',
  'contact.info.email': 'راسلنا',
  'contact.info.phone': 'اتصل بنا',
  'contact.info.hours': 'ساعات العمل',
  'contact.info.hoursValue': 'الاثنين - الجمعة: 8:00 صباحاً - 7:00 مساءً بتوقيت المحيط الهادئ',

  'contact.form.title': 'أرسل لنا رسالة',
  'contact.form.name': 'الاسم الكامل',
  'contact.form.email': 'البريد الإلكتروني',
  'contact.form.subject': 'الموضوع',
  'contact.form.message': 'الرسالة',
  'contact.form.send': 'إرسال الرسالة',

  'contact.map.title': 'موقعنا',
};

export default common;